import { useEffect, useState } from "react";
import { AiOutlineNumber } from "react-icons/ai";
import { IoPersonAddOutline } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";
import Toast from "../../../Components/Toast";
import NewLineTable from "../../../Components/NewLineTable";
import useCompanyStore from "../../../store/useCompanyStore";
import useAuthStore from "../../../store/useAuthStore";
import { FaEye } from "react-icons/fa";

export default function EditInvoice() {
  const navigate = useNavigate();
  const [invoiceDate, setInvoiceDate] = useState("");
  const [dueDate, setDueDate] = useState("");
  const { state } = useLocation();
  const { companyInfo } = useCompanyStore();
  const [invoiceData, setInvoiceData] = useState(state?.entry || {});
  const [error, setError] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [tableData, setTableData] = useState(invoiceData.invoiceItems || []);

  console.log("invoiceData" + invoiceData);

  const headers = [
    { label: "Item", field: "item" },
    { label: "Quantity", field: "qty", type: "number" },
    { label: "Unit Price", field: "unitPrice", type: "number" },
    { label: "Amount", field: "amount", type: "text" },
    { label: "", action: "delete" },
  ];

  const handleRowsChange = (updatedRows) => {
    // Update each row's amount dynamically based on qty and unitPrice
    const calculatedRows = updatedRows.map((row) => {
      const qty = parseFloat(row.qty) || 0; // Use 0 if qty is undefined or not a number
      const unitPrice = parseFloat(row.unitPrice) || 0; // Use 0 if unitPrice is undefined or not a number

      return {
        ...row,
        amount: (qty * unitPrice).toFixed(2), // Calculate amount and format to 2 decimal places
      };
    });

    setTableData(calculatedRows);
    console.log("Updated Table Data:", calculatedRows);
  };

  // total amount in the end of the table
  const calculateTotal = () => {
    return tableData.reduce((acc, row) => {
      const amount = parseFloat(row.amount) || 0;
      return acc + amount;
    }, 0);
  };

  const { token } = useAuthStore();
  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const updatedInvoice = {
        ...invoiceData,
        invoiceItems: tableData, // Send updated invoice items
        date: invoiceDate || invoiceData.date,
      };

      const response = await fetch(
        `/api/updateInvoice/${invoiceData.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(updatedInvoice),
        }
      );

      if (!response.ok) {
        throw new Error(`Failed to update invoice: ${await response.text()}`);
      }

      setShowToast(true);
      setError("");
      setTimeout(() => {
        setShowToast(false);
        navigate("/invoice");
      }, 4000);
    } catch (error) {
      console.error("Error updating invoice:", error);
      alert(`Error: ${error.message}`);
    }
  };

  const [rows, setRows] = useState(
    invoiceData.invoiceItems || [
      { description: "", qty: 0, unitPrice: 0, amount: 0 },
    ]
  );

  useEffect(() => {
    if (invoiceData.invoiceItems) {
      setRows(invoiceData.invoiceItems);
    }
  }, [invoiceData]);

  const HandleDownload = () => {
    const invoiceItems = rows.map((row) => ({
      item: row.item,

      amount: (parseFloat(row.unitPrice) || 0) * (parseInt(row.qty, 10) || 1),
      unitPrice: parseFloat(row.unitPrice) || 0,
      qty: parseInt(row.qty, 10) || 1,
    }));

    // Calculate total
    let total = 0;
    console.log("Total Amount:", total);

    // Calculate total directly using the amount field
    total = invoiceItems.reduce((acc, item) => {
      return acc + item.amount;
    }, 0);

    const PDFData = {
      to: invoiceData?.to || invoiceData?.client,
      clientAddress: invoiceData?.clientAddress || "",
      clientPhone: invoiceData?.clientPhone || "",
      clientEmail: invoiceData?.clientEmail || "",
      title: invoiceData?.title || invoiceData?.name,
      invoiceItems,
      subTotal: total,
      taxRate: invoiceData?.taxRate || 0,
      taxAmount: invoiceData?.taxAmount || 0,
      discount: invoiceData?.discount || 0,
      totalAmount: invoiceData?.totalAmount || total,
      notes: invoiceData?.notes || "",
      terms: invoiceData?.terms || "",
      date: invoiceDate || invoiceData.date?.split("T")[0] || "",
      dueDate: dueDate || invoiceData.dueDate || "",
      companyDetails: {
        name: companyInfo?.name || invoiceData?.companyDetails?.name,
        address: companyInfo?.address || invoiceData?.companyDetails?.address,
        phone: companyInfo?.phone || invoiceData?.companyDetails?.phone,
        email: companyInfo?.email || invoiceData?.companyDetails?.email,
        bankName: companyInfo?.bankName || invoiceData?.companyDetails?.bankName,
        accountNo: companyInfo?.accountNo || invoiceData?.companyDetails?.accountNo,
        logo: companyInfo?.logo || invoiceData?.companyDetails?.logo
      }
    };

    navigate("/InvoicePDF", { state: { PDFData } });
  };

  return (
    <main className="p-5">
      <div className="flex items-center justify-between px-4 bg-white shadow rounded-lg h-[70px] mb-4">
        <span className="text-gray-700 font-semibold text-lg">
          Edit Invoice
        </span>
        <div className="flex gap-2">
          <button
            onClick={HandleDownload}
            className="flex items-center justify-center gap-2 p-2 bg-white border-2 border-slate-900 text-slate-900 rounded-lg hover:bg-slate-50 shadow-md w-[200px] font-black text-xs uppercase italic"
          >
            <FaEye />
            Professional Preview
          </button>
          <button
            onClick={handleUpdate}
            className=" p-2 bg-primary text-white rounded-lg hover:bg-blue-600 shadow-md w-[100px] ml-auto"
          >
            Update
          </button>
        </div>
      </div>
      <section>
        <div className="bg-white p-1 rounded shadow">
          {/* <div className="flex flex-col justify-center"> */}
          <div className="bg-white rounded-lg p-1 flex flex-col justify-center">
            <article>
              <div className="grid grid-cols-3 gap-4 mb-4">
                <div>
                  <label className="block text-sm font-medium mb-1">To</label>
                  <div className="relative">
                    <input
                      type="text"
                      className="border p-2 pl-10 rounded w-full"
                      defaultValue={invoiceData?.client}
                      onChange={(e) =>
                        setInvoiceData({ ...invoiceData, to: e.target.value })
                      }
                      // onChange={(e) => setClientName(e.target.value)}
                      placeholder="Recipient"
                    />
                    <IoPersonAddOutline className="absolute top-5 left-3 transform -translate-y-1/2 text-blue-400 text-xl" />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1">Date</label>
                  <input
                    type="date"
                    className="border p-2 rounded w-full"
                    // value={invoiceDate?.date}
                    defaultValue={invoiceData.date?.split("T")[0] || ""}
                    // onChange={(e) =>
                    //   setInvoiceData({ ...invoiceData, date: e.target.value })
                    // }
                    onChange={(e) => setInvoiceDate(e.target.value)}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1">
                    Due Date
                  </label>
                  <input
                    type="date"
                    className="border p-2 rounded w-full"
                    value={dueDate}
                    onChange={(e) => setDueDate(e.target.value)}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1">
                    Invoice Number
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      name=""
                      className="border p-2 pl-10 rounded w-full"
                      defaultValue={invoiceData?.name}
                      onChange={(e) =>
                        setInvoiceData({
                          ...invoiceData,
                          title: e.target.value,
                        })
                      }
                      placeholder="Invoice #"
                    />
                    <AiOutlineNumber className="absolute top-5 left-3 transform -translate-y-1/2 text-blue-400 text-xl" />
                  </div>
                </div>
              </div>

              {/* Table */}
              <NewLineTable
                headers={headers}
                onRowsChange={handleRowsChange}
                initialRows={tableData}
              />
              <div className="flex justify-end text-xl font-bold w-full -mt-[30px]">
                <span>Total:</span>{" "}
                <span>Nu. {calculateTotal().toFixed(2)}</span>
              </div>
            </article>
          </div>
        </div>
      </section>

      {showToast && (
        <Toast
          type="success"
          title="Invoice Updated Successfully!"
          message="Invoice Updated Successfully!"
          duration={4000}
          onClose={() => setShowToast(false)}
        />
      )}
      {error && <Toast message={error} />}
    </main>
  );
}
